import { render, staticRenderFns } from "./GrowersPage.vue?vue&type=template&id=22994566&"
import script from "./GrowersPage.vue?vue&type=script&lang=js&"
export * from "./GrowersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports